<template>
  <div>
    <ul class="px-4 py-2 space-y-2">
        <div class="ml-8">
          <h2 class="w-full font-semibold text-sm mb-2">From</h2>
          <DatePickerInput @dateChanged="onDateFromChange" mode="date" />
        </div>
        <div class="ml-8">
          <h2 class=" font-semibold text-sm mb-2">To</h2>
          <DatePickerInput @dateChanged="onDateToChange" mode="date" />
        </div>
    </ul>

    <footer class="bg-platinumMild px-4 py-3">
      <button
        @click="applyFilters"
        type="button"
        class="apply-button"
        :disabled="!from || !to || Date.parse(from) > Date.parse(to)"
        dusk="apply-filters-button"
      >
        Apply Filters
      </button>
    </footer>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import DatePickerInput from "@/components/scheduler/Common/DatePickerInput";

var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

export default {
  name: 'DateBetweenFilter',

  components: {
    DatePickerInput
  },

  data: () => ({
    day: "1",
    month: "january",
    year: "2021",
    from: null,
    to: null,
  }),

  methods: {
    applyFilters: function() {
      this.$emit('change', {
        filter: 'date',
        value: `${this.from} - ${this.to}`
      });
    },

    onDateFromChange: function(date) {
      this.from = dayjs(date).format('YYYY/MM/DD');
    },

    onDateToChange: function(date) {
      this.to = dayjs(date).format('YYYY/MM/DD');
    }
  }
}
</script>

<style lang="scss" scoped>
  .apply-button {
    @apply w-full text-yank bg-white border border-platinum transition duration-300 ease-in-out rounded py-2 px-3 font-semibold text-sm hover:border-platinum active:bg-yank active:text-white active:border-yank focus:bg-yank focus:text-white focus:border-yank focus:outline-none;

    &:hover {
      box-shadow: 0 2px 11px rgba(55,54,77,0.08);
    }
  }
</style>